import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import AdminPage from './pages/AdminPage';
import GuestsPage from './pages/GuestsPage';
import ArchivePage from './pages/ArchivePage';
import RegcardPage from './pages/RegcardPage';
import SuccessPage from './pages/SuccessPage';

function PrivateRoute({ children, superadminOnly }) {
  const user = JSON.parse(localStorage.getItem('rc_user') || 'null');
  if (!user) return <Navigate to="/admin/login" replace />;
  if (superadminOnly && user.role !== 'superadmin') return <Navigate to="/admin" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Публичные роуты — для гостя */}
        <Route path="/regcard/:token" element={<RegcardPage />} />
        <Route path="/regcard/success" element={<SuccessPage />} />

        {/* Админ роуты */}
        <Route path="/admin/login" element={<LoginPage />} />
        <Route path="/admin" element={
          <PrivateRoute><AdminPage /></PrivateRoute>
        } />
        <Route path="/admin/archive" element={
          <PrivateRoute><ArchivePage /></PrivateRoute>
        } />
        <Route path="/admin/guests" element={
          <PrivateRoute superadminOnly><GuestsPage /></PrivateRoute>
        } />

        {/* Редиректы */}
        <Route path="/" element={<Navigate to="/admin" replace />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
